import { Grid, Stack, Typography } from "@mui/material";
import { APP_COLORS } from "../../enums";
import type { InitiativeListItem } from "../../api/initiatives";
import { InitiativeSelectableCard } from "../initiatives/InitiativeSelectableCard";
import { InitiativesListSkeleton } from "../initiatives/InitiativesListSkeleton";

export interface ActiveProjectsSectionProps {
  initiatives: InitiativeListItem[];
  loading: boolean;
  selectedInitiativeIds: string[];
  onSelectionChange: (initiative: InitiativeListItem, selected: boolean) => void;
}

export function ActiveProjectsSection({
  initiatives,
  loading,
  selectedInitiativeIds,
  onSelectionChange,
}: ActiveProjectsSectionProps) {
  return (
    <Stack gap={2}>
      <Stack gap={0.5}>
        <Typography
          variant="heading6-helveticaNeue-medium"
          color={APP_COLORS.text}
        >
          Active Initiatives
        </Typography>
        <Typography variant="small-ibmPlexMono" color={APP_COLORS.grey}>
          Please select the private initiatives related to this meeting to help the vendor understand your needs
        </Typography>
      </Stack>
      {loading ? (
        <InitiativesListSkeleton />
      ) : (
        <Grid container spacing={2}>
          {initiatives.map((initiative) => (
            <Grid item xs={12} sm={6} md={4} key={initiative.id}>
              <InitiativeSelectableCard
                initiative={initiative}
                selected={selectedInitiativeIds.includes(initiative.id)}
                onSelectChange={onSelectionChange}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
}
